import React from "react"
import BlogPostPreview from "@/components/BlogPostPreview"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const BlogPostPreviewRow = ({ title, posts, link, linkText }) => {
  const { t } = useTranslation()

  return (
    <div className="blog-post-preview-row">
      {(title || link) && (
        <div className="blog-post-preview-row__title-wrapper">
          {title && (
            <h2 className="mb-0 h4 blog-post-preview-row__title">{title}</h2>
          )}

          {link && (
            <Link className="blog-post-preview-row__link text-link" to={link}>
              {linkText ?? t("blog.home.view-all")}
            </Link>
          )}
        </div>
      )}

      {posts && (
        <div className="blog-post-preview-row__posts">
          {posts.map(post => {
            return <BlogPostPreview post={post} key={post.frontmatter.slug} />
          })}
        </div>
      )}
    </div>
  )
}

export default BlogPostPreviewRow
